import { IRevenueSpendListTableLang } from '../../../types/lang'

export const revenueSpendListTableLang: IRevenueSpendListTableLang = {
	revenue_spend_list_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_date_updated: 'Date Updated_ua',
		column_amount: 'Amount_ua',
		column_account_id: 'Account ID_ua',
		column_account: 'Account_ua',
		column_account_in_group: 'Account in Group_ua',
		column_kt_group: 'KT Group_ua',
		column_agency_id: 'Agency ID_ua',
		column_agency: 'Agency_ua',
		column_history: 'History_ua',
		column_notes: 'Notes_ua'
	}
}